module.exports = __webpack_public_path__ + "img/nabil.9a72a3a2.png";